module.exports = __webpack_public_path__ + "static/media/map-point.ce7ac7d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/map-point.png
// module id = 1131
// module chunks = 0